import MainIcons from '@/icons/main';
import styles from './styles.module.css';
import { cloneElement, isValidElement } from 'react';
import SectionHead from '@/components/general/SectionHead';
import AppImage from '@/components/common/AppImage';

export function AppPromo() {
  const app = {
    kicker: 'اپلیکیشن کارا',
    title: 'کارا را همراهت داشته باش',
    sub: 'تنها با یک کلیک اپلیکیشن کارا را دریافت کن و از استعلام آنی، دستیار هوشمند و یادآوری خودکار سررسیدها لذت ببر.',
    phoneTitle: 'کارا',
    phoneCard: 'مجموع بدهی',
    phoneBtn: 'پرداخت یکجا',
    stores: [
      { name: 'Google Play', small: 'Get it on', icon: <MainIcons.flashIcon /> },
      { name: 'App Store', small: 'Download on', icon: <MainIcons.notifIcon /> },
      { name: 'بازار', small: 'دریافت از', icon: <MainIcons.carIcon /> },
    ],
  };

  return (
    <section className={styles.section}>
      <div className={styles.wrap}>
        <div className={styles.glow} />
        <div className={styles.grid}>
          <div>
            <SectionHead
              title={app?.title}
              text={app?.sub}
              tag={app?.kicker}
              titleClass={styles.title}
              textTitle={styles.sub}
            />
            <div className={styles.stores}>
              {app?.stores.map((st) => (
                <a key={st.name} href="#" className={styles.store}>
                  <div className={styles.storeIcon}>
                    {isValidElement(st?.icon as React.ReactElement<React.SVGProps<SVGSVGElement>>)
                      ? cloneElement(st?.icon, {
                          fill: '#fff',
                          width: `${'16px'}`,
                          height: `${'16px'}`,
                        })
                      : st?.icon}
                  </div>
                  <div className={styles.storeText}>
                    <div className={styles.storeSmall}>{st.small}</div>
                    <div className={styles.storeName}>{st.name}</div>
                  </div>
                </a>
              ))}
            </div>
          </div>

          <div className={styles.phoneWrap}>
            <div className={styles.phone}>
              <div className={styles.screen}>
                <AppImage src="/imgs/home/mobileMain.png" className={`${styles.image}`} />
                {/* <div className={styles.statusBar}>
                  <span className={styles.clock}>9:41</span>
                  <span>{app?.phoneTitle}</span>
                </div>
                <div className={styles.balanceCard}>
                  <div className={styles.balanceLabel}>{app?.phoneCard}</div>
                  <div className={styles.balanceValue}>۱٬۸۴۰٬۰۰۰</div>
                </div>
                <div className={styles.chart}>
                  <div
                    className={styles.cbar}
                    style={{ height: '40%', background: 'var(--green-bright)' }}
                  />
                  <div
                    className={styles.cbar}
                    style={{ height: '62%', background: 'var(--accent-light)' }}
                  />
                  <div
                    className={styles.cbar}
                    style={{ height: '48%', background: 'var(--brand-light)' }}
                  />
                  <div className={styles.cbar} style={{ height: '80%', background: '#ff5a6e' }} />
                  <div
                    className={styles.cbar}
                    style={{ height: '55%', background: 'var(--brand-light)' }}
                  />
                </div>
                <div className={styles.payBtn}>{app?.phoneBtn}</div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
